import { Component, Input, inject } from '@angular/core';
import { RoutingService } from '@nano/common/routing';
import { CONFIG } from '@nano/core/config';
import { L10nService } from '@nano/core/l10n';

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.component.less'],
  standalone: false
})
export class HeaderComponent {
  @Input() authorized: boolean;
  @Input() authenticated: boolean;

  readonly multilingual$ = this.l10nService.multilingual$;

  messagesEnabled: boolean;

  private logoLinkAuthorized: string;
  private logoLinkUnauthorized: string;

  private config = inject(CONFIG);

  constructor(
    private l10nService: L10nService,
    private routingService: RoutingService
  ) {
    this.logoLinkAuthorized = this.config.logoLinkAuthorized;
    this.logoLinkUnauthorized = this.config.logoLinkUnauthorized;
    this.messagesEnabled = this.config.messagesEnabled;
  }

  logoClicked(): void {
    const logoLink: string = this.authenticated ? this.logoLinkAuthorized : this.logoLinkUnauthorized;
    if (logoLink) {
      window.location.href = logoLink;
    } else {
      this.routingService.navigateToRoot();
    }
  }
}
